import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../components/ui/dialog';
import { Plus, Edit, Trash2 } from 'lucide-react';
import { toast } from 'sonner';

const empty = { name:'', code:'', city:'', type:'airport', lat:0, lng:0 };

const AdminAirports = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);

  const load = () => api.get('/airports').then(r => setItems(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { ...form, lat: parseFloat(form.lat) || 0, lng: parseFloat(form.lng) || 0 };
      if (editing) await api.put(`/airports/${editing.id}`, payload);
      else await api.post('/airports', payload);
      toast.success('Guardado');
      setOpen(false); load();
    } catch { toast.error('Error'); }
  };
  const remove = async (id) => {
    if (!window.confirm('¿Eliminar?')) return;
    try { await api.delete(`/airports/${id}`); toast.success('Eliminado'); load(); } catch { toast.error('Error'); }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-black text-white">Aeropuertos & Puertos</h1>
          <p className="text-white/60">Gestiona aeropuertos y puertos disponibles</p>
        </div>
        <Button onClick={() => { setEditing(null); setForm(empty); setOpen(true); }} className="btn-orange border-0 gap-2"><Plus className="w-4 h-4" /> Nuevo</Button>
      </div>

      <div className="glass-card rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-black/60 text-white/70">
            <tr><th className="text-left p-4">Nombre</th><th className="text-left p-4">Código</th><th className="text-left p-4">Ciudad</th><th className="text-left p-4">Tipo</th><th className="text-left p-4">Acciones</th></tr>
          </thead>
          <tbody>
            {items.map(a => (
              <tr key={a.id} className="border-t border-white/5">
                <td className="p-4 text-white">{a.name}</td>
                <td className="p-4 text-[#ff6b1a] font-bold">{a.code}</td>
                <td className="p-4 text-white/70">{a.city}</td>
                <td className="p-4 text-white/70 capitalize">{a.type}</td>
                <td className="p-4">
                  <div className="flex gap-2">
                    <button onClick={() => { setEditing(a); setForm({ ...a }); setOpen(true); }} className="w-8 h-8 rounded bg-white/5 text-white/70 hover:bg-white/10 flex items-center justify-center"><Edit className="w-4 h-4" /></button>
                    <button onClick={() => remove(a.id)} className="w-8 h-8 rounded bg-red-600/20 text-red-400 hover:bg-red-600/40 flex items-center justify-center"><Trash2 className="w-4 h-4" /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#0f0f0f] border-white/10 text-white">
          <DialogHeader><DialogTitle>{editing ? 'Editar' : 'Nuevo'}</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-4">
            <div className="col-span-2"><Label>Nombre</Label><Input value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Código</Label><Input value={form.code} onChange={(e)=>setForm({...form,code:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Ciudad</Label><Input value={form.city} onChange={(e)=>setForm({...form,city:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Tipo</Label>
              <Select value={form.type} onValueChange={(v)=>setForm({...form,type:v})}>
                <SelectTrigger className="bg-black/40 border-white/10"><SelectValue /></SelectTrigger>
                <SelectContent className="bg-[#0f0f0f] border-white/10">
                  <SelectItem value="airport" className="text-white">Aeropuerto</SelectItem>
                  <SelectItem value="port" className="text-white">Puerto</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div><Label>Latitud</Label><Input type="number" step="0.0001" value={form.lat} onChange={(e)=>setForm({...form,lat:e.target.value})} className="bg-black/40 border-white/10" /></div>
            <div><Label>Longitud</Label><Input type="number" step="0.0001" value={form.lng} onChange={(e)=>setForm({...form,lng:e.target.value})} className="bg-black/40 border-white/10" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={()=>setOpen(false)} className="border-white/15 text-white">Cancelar</Button>
            <Button onClick={save} className="btn-orange border-0">Guardar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AdminAirports;
